import { AlertTriangle, Unplug } from 'lucide-react'

import { useCadencia, useOperacao, useSaudeBase } from './api/operacao-api'
import { FaixaCadencia, FaixaOperacao, FaixaSaudeBase } from './faixas'

import type { FiltroPeriodo } from '@/features/relatorio/api/relatorio-api'
import type { ReactElement } from 'react'

import { ApresentacaoCarregando } from '@/features/apresentacao/apresentacao-carregando'

/**
 * Os três blocos num slide só. Separá-los em três slides deixaria telas com um
 * ou dois cards no telão; juntos preenchem a tela e a divisão continua explícita
 * pelo cabeçalho de cada faixa.
 */
export function BlocoOperacaoDenso({ periodo }: { periodo: FiltroPeriodo }): ReactElement {
  const base = useSaudeBase(periodo)
  const operacao = useOperacao(periodo)
  const cadencia = useCadencia(periodo)

  // Erro NÃO pode virar "carregando" eterno: no telão, um slide girando para
  // sempre no meio da reunião é pior que dizer que a coleta falhou.
  if (base.isError || operacao.isError || cadencia.isError) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <AlertTriangle className="text-destructive h-10 w-10" aria-hidden />
        <p className="text-lg font-medium">Base, Operação e Cadência indisponíveis</p>
        <p className="text-muted-foreground text-base">A coleta no ClickUp falhou.</p>
      </div>
    )
  }

  if (!base.data || !operacao.data || !cadencia.data) {
    return <ApresentacaoCarregando titulo="Base, Operação e Cadência" />
  }

  // Integração sem lista apontada: dizer isso no telão evita apresentar um slide
  // de zeros como se fosse resultado da operação.
  if (!base.data.configurado && !operacao.data.configurado && !cadencia.data.configurado) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <Unplug className="text-muted-foreground h-10 w-10" aria-hidden />
        <p className="text-lg font-medium">Blocos ainda não configurados</p>
        <p className="text-muted-foreground text-base">
          Aponte as listas do ClickUp nas variáveis de ambiente para estes blocos medirem.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-8">
      <FaixaSaudeBase dados={base.data} telao />
      <FaixaOperacao dados={operacao.data} telao />
      <FaixaCadencia dados={cadencia.data} telao />
    </div>
  )
}
